import {call, put, select} from 'redux-saga/effects';
import {ISkeletonSaga, skeletonSaga} from '../../apis/skeleton/skeletonSaga';
import {GetCurrentOddsCall} from "../../apis/dropping";
import {GET_CURRENT_ODDS_SUCCESS} from "../../constants/OddsConstants";
import {GENERIC_ERROR} from "../../constants/ErrorConstants";
import {getFixtures} from "../../store/selectors/getFixtures";
import {DroppingOddObject, EventsStoredObjects} from "../../@types/response";

// La call dropping ritorna solo id + dati di processing: l'anagrafica
// (name/category/competition/date/sport) va letta da common.fixtures.
function* tryFunction(payload: number) {
    const response: DroppingOddObject[] = yield call(GetCurrentOddsCall, payload);
    const fixtures: EventsStoredObjects = yield select(getFixtures);
    const hydrated = (response ?? []).map((item) => {
        const fixture = fixtures[item.id];
        if (!fixture) return item;
        return {
            ...item,
            name: fixture.name,
            category: fixture.category,
            competition: fixture.competition,
            sport: fixture.sport,
            sportId: fixture.sportId,
            date: fixture.date,
        };
    });
    yield put({
        type: GET_CURRENT_ODDS_SUCCESS,
        payload: hydrated,
        bookmakerId: payload
    });
}

export function* getCurrentPinnacleOddsSaga(): Generator {
    const sagaPayload: ISkeletonSaga = {
        tryApiCall: {function: tryFunction, payload: 3},
        failedType: GENERIC_ERROR
    };
    yield call(skeletonSaga, sagaPayload);
}

export function* getCurrentBetfairOddsSaga(): Generator {
    const sagaPayload: ISkeletonSaga = {
        tryApiCall: {function: tryFunction, payload: 2},
        failedType: GENERIC_ERROR
    };
    yield call(skeletonSaga, sagaPayload);
}